// extracted by mini-css-extract-plugin
module.exports = {"formBanner":"styles_formBanner__3wcAY","inputForm":"styles_inputForm__3DSUU","previewBanner":"styles_previewBanner__3KZis","overview":"styles_overview__3okyC"};